import React, { useEffect } from 'react'
import './index.scss'

class Dialog extends React.Component {
  constructor(props) {
    super(props)
  }

  setTab(name, label) {
    this.setState({ selectedTab: name, headerValue: '' })
  }

  newMakeTab(properties, tabWidth) {
    const { selectedTab } = this.state,
      { tab, label, active, inactive, iconName, borderCOlor, onShapeChange, key, keyVal, onTabValue, disabled } = properties
    const iconPath = iconName ? require(`../../../../../asset/mapToolsIcons/${iconName}`) : '';

    let onselectShape = (value) => {
      onShapeChange(value)
    }
    let onStateChange = () => {
      onTabValue && onTabValue(label)
    }
    const handleClick = () => {
      if (disabled) return
      if (selectedTab !== tab) {
        this.setTab(tab, label)
        if (tab === 'drawObjects') {
          onselectShape(keyVal)
        }
        onStateChange && onStateChange()
      }
    }
    return (
      <div
        className='tools-items-tab-style'
        key={key}
        style={disabled ? { opacity: 0.4, cursor: 'not-allowed', pointerEvents: 'none' } : {}}
        title={disabled ? 'Not available in 3D mode' : undefined}
      >
        {borderCOlor != null ?
          <>
            <div className='icon-border-style'
              style={{ border: `2px solid ${borderCOlor ? borderCOlor : '#FF6800'}` }}
              onClick={handleClick}
              key={`tab-${tab}`}
            >
              <img className='icon-style'
                src={iconPath}
              ></img>
            </div>
            <div className='toolbar-navigation-label'>
              {label === 'HuntWind' ? <p>HuntWind&#8482;</p> : label}
            </div>
          </>
          :
          <>
            <img className='icon-style-without-border'
              src={iconPath}
              onClick={handleClick}
              key={`tab-${tab}`}
            ></img>
            <div className='toolbar-navigation-label'>
              {label === 'HuntWind' ? <p>HuntWind&#8482;</p> : label}
            </div>
          </>
        }
      </div>
    )
  }

  makeTab(properties, tabWidth) {
    const { selectedTab } = this.state,
      { tab, label, active, inactive } = properties
    return (
      <div className={`left-expanded-tab-${selectedTab === tab ? 'active' : 'inactive'}`}
        style={{ width: tabWidth }}
        onClick={() => {
          if (selectedTab !== tab) {
            this.setTab(tab)
          }
        }}
        key={`tab-${tab}`}
      >
        <img className='left-expanded-tab-img'
          src={selectedTab === tab ? active : inactive}
        ></img>
        <div className={`left-expanded-tab-label-${selectedTab === tab ? 'active' : 'inactive'}`}>
          {label === 'HuntWind' ? <p>HuntWind&#8482;</p> : label}
        </div>
      </div>
    )
  }

  makeLayersTab(properties, tabWidth) {
    const { selectedTab } = this.state,
      { tab, label, active, inactive } = properties
    return (
      <div className={`map-layer-tab-${selectedTab === tab ? 'active' : 'inactive'}`}
        style={{ width: tabWidth }}
        onClick={() => {
          if (selectedTab !== tab) {
            this.setTab(tab)
          }
        }}
        key={`tab-${tab}`}
      >
        <div className={`map-layer-tab-label-${selectedTab === tab ? 'active' : 'inactive'}`}>
          {label === 'HuntWind' ? <p>HuntWind&#8482;</p> : label}
        </div>
      </div>
    )
  }

  render() {
    console.error('Must override dialog render function: left-toolbar')
    return (
      null
    )
  }
}

export default Dialog